async function getTarif(id, targetIds, tpl, showCategory = 0) {
  const formData = new FormData();
  // Преобразуем targetIds в объект, если передана строка (для обратной совместимости)
  const targets = typeof targetIds === 'string' ? { main: targetIds } : targetIds;

  // Добавляем класс loading ко всем целевым элементам
  Object.values(targets).forEach(targetId => {
    const el = document.getElementById(targetId);
    if (el) el.classList.add('loading');
  });

  formData.append('action', 'getTarif')
  formData.append('tpl', tpl)
  formData.set('id',id)
  try {
      const response = await fetch('/ajax.php', {
          method: 'POST',
          body: formData,
      });
      
      const data = await response.json();

      // Обновляем все целевые элементы
      for (const [key, targetId] of Object.entries(targets)) {
        const element = document.getElementById(targetId);
        if (element && data[key]) {
          element.innerHTML = data[key];
          element.classList.remove('loading');
        }
      }     

      // Добавляем GET-параметры к текущему URL
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('type', data.alias || ''); 
      if (showCategory  && data.parent) {
        currentUrl.searchParams.set('category', data.parent)
      }

      // Обновляем URL
      history.pushState({  }, '', currentUrl.toString());

      manageCTogglers()
      setIconsNiceSelect()
      setMultyNiceSelect()
      initTarifsSlider()
      initInterfaceSlider()
      const getTarifLoadedEvent = new CustomEvent('getTarifLoadedCustomEvent')
      document.dispatchEvent(getTarifLoadedEvent);
      

  } catch (error) {
      console.error('error:', error);
      
      // Убираем loading при ошибке
      // Object.values(targets).forEach(targetId => {
      //   const el = document.getElementById(targetId);
      //   if (el) el.classList.remove('loading');
      // });
  }
}
async function getResource(id, action,targetId, tpl) {
  const formData = new FormData();
  const targetElement =document.getElementById(targetId)
  targetElement.classList.add('loading')
  formData.append('action', action)
  formData.append('tpl', tpl)
  formData.set('id',id)
  try {
      const response = await fetch('/ajax.php', {
          method: 'POST',
          body: formData,
      });
      
      const data = await response.json();
      
      document.getElementById(targetId)
      targetElement.innerHTML = data.content
      targetElement.classList.remove('loading')      

      // Добавляем GET-параметры к текущему URL
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('type', data.alias); 

      // Обновляем URL
      history.pushState({  }, '', currentUrl.toString());

      manageCTogglers()
      setIconsNiceSelect()
      setMultyNiceSelect()
      initTarifsSlider()
      initInterfaceSlider()


  } catch (error) {
      console.error('error:', error);
  }
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift(); // Получаем значение куки
    }
    return null; // Если куки не существует
}

//month year price toggler
function changePaidPeriod(period,elementId) {
  let element = document.getElementById(elementId)
  if (!element) return
  element.querySelectorAll('._price-block').forEach(c => {
    if (c.dataset.period == period) {
      c.classList.remove('d-none')
    } else {
      c.classList.add("d-none")
    }
  })
}

// const dateCTogglers = document.querySelectorAll('.premade-date.c-toggler input[type="radio"]');
// if (dateCTogglers) {
//   dateCTogglers.forEach((dateCTogglers) => {
//       dateCTogglers.addEventListener('change', (el) => {
//         el.target.closest('.premade-top').nextElementSibling.querySelectorAll('._price-block').forEach(c => {
//           if (c.dataset.period == el.target.value) {
//             c.classList.remove('d-none')
//           } else {
//             c.classList.add("d-none")
//           }
//         })
//       })
//   })
// }
          




document.addEventListener("fetchit:success", (e) => {
  const { response } = e.detail;
  // console.log(e.detail.form)
  if (response.success) {
      let form = e.detail.form;
      // console.log(form);
      // formSuccessMessage(form);
      let formWrap= form.closest('.form-wrapper')
      // console.log(formWrap)
      form.classList.add('hidden')
      formWrap.querySelector('.success_send').classList.add('opened')
      // console.log(response)
  }
})